import axios from "axios";
import "../components/Error";
import { getEnv } from "../components/helpers/Config";
import i18n from "i18next";
import i18next from "i18next";

// "homepage": "https://recallrtr-test.azurewebsites.net/FiguresandNets",
export const Axios = {
  email,
  addressValidation,
  shippingLabel,
};
function email(data, instance) {
  const tSubject = i18next.t("email.subject");

  const name = data.firstName + " " + data.lastName;
  const phone = data.phoneNumber;
  const email = data.email;
  const abc = data.abc && data.abc !== "" ? data.abc : "0";
  const count =
    data.animalCounting && data.animalCounting !== ""
      ? data.animalCounting
      : "0";
  const dino = data.dinosaur && data.dinosaur !== "" ? data.dinosaur : "0";
  const macDonald =
    data.macDonald && data.macDonald !== "" ? data.macDonald : "0";
  const rainbow = data.rainbow && data.rainbow !== "" ? data.rainbow : "0";
  const oldLady = data.oldLady && data.oldLady !== "" ? data.oldLady : "0";
  const go =
    data.thingsThatGo && data.thingsThatGo !== "" ? data.thingsThatGo : "0";
  const unicorn = data.unicorn && data.unicorn !== "" ? data.unicorn : "0";
  const bottom = data.bottom && data.bottom !== "" ? data.bottom : "0";
  const code = data.code;

  let address = data.address;
  var attention = "";
  var address2 = data.city + ", " + data.state + " " + data.postalCode;
  if (data.attentionTo) {
    attention = data.attentionTo;
  } else {
    attention = data.firstName + " " + data.lastName;
  }
  // if (data.country === "US") {
  //   address2 = data.city + ", " + data.state + " " + data.postalCode;
  // } else {
  //   address2 = data.city + ", " + data.province + " " + data.postalCode;
  // }

  if (data.address2) {
    address = address + ", " + data.address2;
  }
  var emailText = "";
  var tableText = "";

  if (
    data.region === "Armenia" ||
    data.region === "Bermuda" ||
    data.region === "Brunei" ||
    data.region === "Costa Rica" ||
    data.region === "Ecuador" ||
    data.region === "Guatemala" ||
    data.region === "Honduras" ||
    data.region === "Jordan" ||
    data.region === "Kyrgyzstan" ||
    data.region === "Maldives" ||
    data.region === "Mongolia" ||
    data.region === "Panama" ||
    data.region === "Seychelles" ||
    data.region === "St. Maarten"
  ) {
    emailText = `<p style='color: black;'>${i18next.t(
      "email.textA1"
    )}</p><p style='color: black;'>${i18next.t(
      "email.textC1"
    )}</p><p style='color: black; font-weight: bold;'>${i18next.t(
      "email.textD1"
    )}</p>`;
  } else if (data.region === "Cyprus") {
    emailText = `<p style='color: black;'>${i18next.t(
      "email.textA2"
    )}</p><p style='color: black;'>${i18next.t(
      "email.textC2"
    )}</p><p style='color: black; font-weight: bold;'>${i18next.t(
      "email.textD2"
    )}</p>`;
  } else if (data.region === "United States") {
    emailText = `<p style='color: black;'>${i18next.t(
      "email.textA"
    )}</p><p style='color: black;'>${i18next.t(
      "email.textB"
    )}</p><p style='color: black; font-weight: bold;'>${i18next.t(
      "email.textD"
    )}</p>`;
  } else {
    emailText = `<p style='color: black;'>${i18next.t(
      "email.textA"
    )}</p><p style='color: black;'>${i18next.t(
      "email.textC"
    )}</p><p style='color: black; font-weight: bold;'>${i18next.t(
      "email.textD"
    )}</p>`;
  }
  let recipients = [email];
  let BccRecipients = ["rr@realtimeresults.net"];
  var emailToSend = {
    EmailFrom: "recallrtr@realtimeresults.net",
    Subject: tSubject,
    IsHtml: true,
    DisplayName: "no-reply@realtimeresults.net",
    Recipients: recipients,
    BccRecipients: BccRecipients,
    Body:
      `<h2 style='color: black; font-weight: bold;text-align:center;'>${i18next.t(
        "email.header"
      )}</h2><br /><h3 style='color: black;text-align:center;'>${i18next.t(
        "email.header1"
      )}</h3><br /><h3 style='color: black;text-align:center;'>${i18next.t(
        "email.id"
      )} ${instance}</h3>
      <table><tr><td><p style='color: black; font-weight: bold;'>${i18next.t(
        "email.name"
      )}</p></td><td></td><td><p style='color: black;'>${name}</p></td></tr>
    <tr><td><p style='color: black; font-weight: bold;'>${i18next.t(
      "email.address"
    )}</p></td><td></td><td><p style='color: black;'>${address}</p></td></tr>
      <tr><td><p style='color: black; font-weight: bold;'></p></td><td></td><td><p style='color: black;'>${address2}</p></td></tr>
      <tr><td><p style='color: black; font-weight: bold;'>${i18next.t(
        "email.email"
      )}</p></td><td></td><td><p style='color: black;'>${email}</p></td></tr>
      <tr><td><p style='color: black; font-weight: bold;'>${i18next.t(
        "email.phone"
      )}</p></td><td></td><td><p style='color: black;'>${phone}</p></td></tr>
      <tr><td><p style='color: black; font-weight: bold;'>${i18next.t(
        "email.shipTo"
      )}</p></td><td></td><td><p style='color: black;'>${attention}</p></td></tr>
      <tr><td><p style='color: black; font-weight: bold;'>${i18next.t(
        "email.code"
      )}</p></td><td></td><td><p style='color: black;'>${code}</p></td></tr>
      <tr><td><p style='color: black; font-weight: bold;'>${i18next.t(
        "email.title"
      )}</p></td><td></td><td><p style='color: black;'></p></td></tr>
      <tr><td><p style='color: black; font-weight: bold;'>${i18next.t(
        "step5.table1A"
      )}</p></td><td></td><td><p style='color: black;'>${abc}</p></td></tr>
      <tr><td><p style='color: black; font-weight: bold;'>${i18next.t(
        "step5.table1B"
      )}</p></td><td></td><td><p style='color: black;'>${count}</p></td></tr>
      <tr><td><p style='color: black; font-weight: bold;'>${i18next.t(
        "step5.table1C"
      )}</p></td><td></td><td><p style='color: black;'>${dino}</p></td></tr>
      <tr><td><p style='color: black; font-weight: bold;'>${i18next.t(
        "step5.table1D"
      )}</p></td><td></td><td><p style='color: black;'>${macDonald}</p></td></tr>
      <tr><td><p style='color: black; font-weight: bold;'>${i18next.t(
        "step5.table1E"
      )}</p></td><td></td><td><p style='color: black;'>${rainbow}</p></td></tr>
      <tr><td><p style='color: black; font-weight: bold;'>${i18next.t(
        "step5.table1F"
      )}</p></td><td></td><td><p style='color: black;'>${oldLady}</p></td></tr>
      <tr><td><p style='color: black; font-weight: bold;'>${i18next.t(
        "step5.table1G"
      )}</p></td><td></td><td><p style='color: black;'>${go}</p></td></tr>
      <tr><td><p style='color: black; font-weight: bold;'>${i18next.t(
        "step5.table1H"
      )}</p></td><td></td><td><p style='color: black;'>${unicorn}</p></td></tr>
      <tr><td><p style='color: black; font-weight: bold;'>${i18next.t(
        "step5.table1I"
      )}</p></td><td></td><td><p style='color: black;'>${bottom}</p></td></tr>
      </table>` +
      emailText +
      `<p style='color: grey;'>${i18next.t("email.footer")}</p>`,
  };
  let url = getEnv();
  axios({
    method: "post",
    url: url + "/api/StaticData/SendEmail",
    data: emailToSend,
  })
    .then((response) => {
      console.log("success");
      return true;
    })
    .catch((response) => {
      console.log("fail");
      return false;
    });
}
function addressValidation(data) {
  let url = getEnv();
  var person = {
    Name: data.firstName + " " + data.lastName,
    Address: data.address,
    Address2: data.address2,
    City: data.city,
    State: data.state,
    Country: "US",
    PostalCode: data.postalCode,
  };
  axios({
    method: "post",
    url: url + "/Verification/Address",
    data: person,
  })
    .then((response) => {
      console.log("success");
      let responseNumber = Object.keys(response).length;
      var returnResponse = {
        Message: response[0].responseMessage,
        Valid: true,
      };
      if (responseNumber > 1) {
        returnResponse.Valid = false;
        return returnResponse;
      }
      if (returnResponse.Message === "Invalid UPS Shipping Address.") {
        returnResponse.Message =
          "Mailing address is not recognized.  Please verify the information in all fields and correct where needed. If you want to submit the registration with the address as listed, check the box below.";
        returnResponse.Valid = false;
        return returnResponse;
      }
      returnResponse.Address = response[0].address;
      returnResponse.Address = response[0].city;
      returnResponse.Address = response[0].state;
      returnResponse.Address = response[0].postalCode;
    })
    .catch((response) => {
      var returnResponse = {
        Message: response[0].responseMessage,
        Valid: false,
      };
      return returnResponse;
    });
}
function shippingLabel(data, instance, definitionID) {
  let url = getEnv();
  var person = {
    Name: data.firstName + " " + data.lastName,
    Address: data.address,
    Address2: data.address2,
    City: data.city,
    State: data.state,
    Country: "US",
    PostalCode: data.postalCode,
  };
  axios({
    method: "post",
    url: url + "Shipping/" + definitionID + "/upsLabel/" + instance,
    data: person,
  })
    .then((response) => {
      console.log("success");
      return true;
    })
    .catch((response) => {
      return false;
    });
}
